export const GIFT = 'gift';

export const redeemGiftColumns = [
  { id: 'redemptionCode', label: 'Redemption Code' },
  { id: 'balance', label: 'Balance' },
  { id: 'redeemedAt', label: 'Redemption Date' },
];
